import { SvgIcon } from "@material-ui/core";

export const SingleItemIcon = ({
  className,
  fontSize = 80,
}: {
  className?: string;
  fontSize?: number;
}) => {
  return (
    <SvgIcon
      className={className}
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      style={{ fontSize }}
    >
      <mask
        id="mask0_1_49"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="6"
        width="80"
        height="68"
      >
        <path d="M0 6.00001H80V73.093H0V6.00001Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1_49)">
        <path
          d="M17.9587 33.8372V26.9767C17.9587 24.7674 19.7029 23.0232 21.9122 23.0232H54.0051C56.2144 23.0232 57.9586 24.7674 57.9586 26.9767V33.8372C60.4005 33.8372 62.3772 35.8139 62.3772 38.2558V46.3953V54.0697H14.0052V46.3953V38.2558C13.8889 35.9302 15.7494 34.0697 17.9587 33.8372Z"
          fill="#F1CCA5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.9819 51.0465C60.6331 51.0465 60.2842 51.3953 60.2842 51.7441V58.2558C60.2842 58.6046 60.6331 58.9534 60.9819 58.9534C61.3307 58.9534 61.6796 58.6046 61.6796 58.2558V51.7441C61.6796 51.279 61.3307 51.0465 60.9819 51.0465Z"
          fill="#EA7200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.4703 51.0465C19.1215 51.0465 18.7726 51.3953 18.7726 51.7441V58.2558C18.7726 58.6046 19.1215 58.9534 19.4703 58.9534C19.8191 58.9534 20.168 58.6046 20.168 58.2558V51.7441C20.168 51.279 19.9354 51.0465 19.4703 51.0465Z"
          fill="#EA7200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.3307 37.9069C56.3307 37.5581 56.0982 37.3255 55.7493 37.3255H24.9354C24.5866 37.3255 24.354 37.5581 24.354 37.9069C24.354 38.2558 24.5866 38.4883 24.9354 38.4883H55.7493C55.9819 38.4883 56.3307 38.2558 56.3307 37.9069Z"
          fill="#006A36"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.5168 35.9302C25.5168 33.1395 23.3075 30.8139 20.4005 30.8139C17.6098 30.8139 15.2842 33.1395 15.2842 35.9302V52.4418H65.0517V35.9302C65.0517 33.1395 62.8424 30.8139 59.9354 30.8139C57.1447 30.8139 54.8191 33.0232 54.8191 35.9302V43.3721H25.4005V35.9302H25.5168ZM20.4005 32.2093C22.4935 32.2093 24.1214 33.8372 24.1214 35.9302V44.6511H56.3307V35.9302C56.3307 33.8372 57.9586 32.2093 60.0517 32.2093C62.1447 32.2093 63.7726 33.8372 63.7726 35.9302V51.0465H16.7959V35.9302C16.6796 33.8372 18.4238 32.2093 20.4005 32.2093Z"
          fill="#EA7200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.0051 20C21.447 20 19.354 22.093 19.354 24.6511V31.5116H20.7494V24.6511C20.7494 22.7907 22.261 21.3953 24.0051 21.3953H56.0982C57.9586 21.3953 59.354 22.9069 59.354 24.6511V31.5116H60.7493V24.6511C60.7493 22.093 58.6563 20 56.0982 20H24.0051Z"
          fill="#EA7200"
        />
      </g>
    </SvgIcon>
  );
};
